import { DateRangeState, FilterRoute } from '@zonofi/zono-money-store';
import moment from 'moment';
import { DATE_RANGE_FILTERS } from '../components/filter/date-range-filters';
import { DateRangeKeys } from '../types';

export const getDefaultDateRange = (route?: FilterRoute): DateRangeState => {
  switch (route) {
    case FilterRoute.CustomerOrder:
    case FilterRoute.CustomerInvoice:
    case FilterRoute.CustomerPayment:
      return DATE_RANGE_FILTERS[DateRangeKeys.Last3Months];
    case FilterRoute.SemanticQuery:
      return DATE_RANGE_FILTERS[DateRangeKeys.Today];
    default:
      return {
        key: 'selection',
        startDate: moment().subtract(6, 'days').toDate(),
        endDate: moment().toDate(),
      };
  }
};

export const defaultDateRangeValue = {
  key: 'selection',
  startDate: moment().subtract(6, 'days').toDate(),
  endDate: moment().toDate(),
};
export const getTextFromRange = (
  range: DateRangeState,
  route?: FilterRoute
): string => {
  const defaultDateRangeValue = getDefaultDateRange(route);
  const startDate = range?.startDate
    ? moment(range?.startDate).startOf('day')
    : moment(defaultDateRangeValue.startDate);
  const endDate = range?.endDate
    ? moment(range?.endDate).endOf('day')
    : moment(defaultDateRangeValue.endDate);

  for (const key in DATE_RANGE_FILTERS) {
    const predefined = DATE_RANGE_FILTERS[key as DateRangeKeys];

    const predefinedStart = moment(predefined.startDate).startOf('day');
    const predefinedEnd = moment(predefined.endDate).endOf('day');

    if (predefinedStart.isSame(startDate) && predefinedEnd.isSame(endDate)) {
      return key;
    }
  }

  return `${startDate.format('DD MMM, YY')} ${
    startDate.format('DD MMM, YY') === endDate.format('DD MMM, YY')
      ? ''
      : `- ${endDate.format('DD MMM, YY')}`
  }`;
};
